import { render, staticRenderFns } from "./WizardStepIntro.vue?vue&type=template&id=6a006994&"
import script from "./WizardStepIntro.vue?vue&type=script&lang=js&"
export * from "./WizardStepIntro.vue?vue&type=script&lang=js&"
import style0 from "./WizardStepIntro.vue?vue&type=style&index=0&id=6a006994&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports